import * as type from '../actions/types';

const initialState = {
  data: null,
  fetching: false,
  error: false,
  errorMessage: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_FRESH_EXISTING_PROMOTIONS_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };

    case type.FETCH_FRESH_EXISTING_PROMOTIONS_SUCCESS: {
      let parsedData = action.payload.data;

      if (typeof parsedData === 'string') {
        try {
          parsedData = JSON.parse(parsedData);
        } catch (e) {
          console.error('Failed to parse fresh existing promotions data:', e);
          parsedData = null;
        }
      }

      return {
        ...state,
        fetching: false,
        data: parsedData,
        success: true,
        error: false,
      };
    }

    case type.FETCH_FRESH_EXISTING_PROMOTIONS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };

    default:
      return state;
  }
};
